import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import AccountForm from '../containers/AccountFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class AccountEditScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `AccountEditScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('account_route_edit')} />
          <AccountForm id={this.props.match.params.id} />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default AccountEditScreen;

Logger.log('silly', `AccountEditScreen loaded.`);
